import { useStaticQuery, graphql } from "gatsby"
import localityNames from "../data/locality_mapping.json"

export default function LocalityData() {
	const query = graphql`
		query ClanLocalityData {
			allCclansLocalityCsv(filter: {latitude: {ne: ""}}) {
				nodes {
					ccchi
					cceng
					cchypy
					id
					yearest
					address
					phone
					member
					locality
					latitude
					longitude
					website
				}
			}
		}
	`

	const { allCclansLocalityCsv } = useStaticQuery(query) || {}

	return allCclansLocalityCsv?.nodes
					.map(node => ({
						...node,
						localityCode: node.locality.toLowerCase(),
						locality: node.locality === ""
								? "--"
								: localityNames[node.locality.toLowerCase()],
						longitude: parseFloat(node.longitude),
						latitude: parseFloat(node.latitude),
					  type: "L",
					}))

}
